<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import PickerMixin from "@/mixins/PickerMixin"

const { mapActions } = createNamespacedHelpers("skill_category")
export default {
  name: "SkillCategoryPicker",
  mixins: [PickerMixin],
  data: () => ({
    search: "",
    loading: false,
  }),

  computed: {
    items() {
      return this.$store.state.skill_category.data
    },
  },

  methods: {
    ...mapActions([FETCH]),

    itemText(item) {
      return item.name
    },
  },
}
</script>
